import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import AssetItem from './item'
import DropdownButton from 'widget/dropdown-button'
import prettysize from 'prettysize'

/* Utilities */
import _ from 'lodash'

/* Widgets */
import InfoText from 'widget/info-text'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'
import {
  cancelUpload
} from 'react-redux/actions/asset'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'


/* Selectors */
import { getUploadItem } from 'react-redux/selectors/asset'

/* Styles */
import "./upload.css"

/* Single Asset Item shown in asset list */
class AssetUpload extends Component {

  constructor() {
    super()
    this.state = {
    }
  }

  componentDidMount() { }

  componentWillReceiveProps(nextProps) { }



  getListItemClass() {
    const {  } = this.props
    var className = "asset-upload component"
    return className
  }

  onRemoveClick() {
    const { cancelUpload, tid } = this.props
    cancelUpload(tid)
  }

  getToolbarItems() {
    const { t, completed, name, size, type, progress }  = this.props
    let percent = Math.round(progress*100)+"%"
    let items = []
    if(!completed) {
      items.push(
        {
          name: t("asset:item.remove"),
          title: t("asset:item.remove"),
          icon: ICON.OFFLINE,
          iconScheme: ICON_SCHEME.DANGER,
          onClick: this.onRemoveClick.bind(this)
        }
      )
    }
    items.push({ type: "seperator" })
    items.push({
      name: t('asset:upload.fileName', {name}),
      title:  t('asset:upload.fileNameTitle'),
      style: "info"
    })
    items.push({
      name: t('asset:upload.fileType', {type}),
      title:  t('asset:upload.fileTypeTitle'),
      style: "info"
    })
    items.push({
      name: t('asset:upload.fileSize', {size: prettysize(size)}),
      title:  t('asset:upload.fileSizeTitle'),
      style: "info"
    })
    if (!completed) {
      const sizeUploaded = prettysize(Math.round(size*progress))
      items.push({
        name: t('asset:upload.uploadedSize', {size: sizeUploaded}),
        title:  t('asset:upload.uploadedSizeTitle'),
        style: "info"
      })
    }
    return items
  }

  renderItemToolbar() {
    const { t } = this.props
    return (
      <span className="toolbar">
        <DropdownButton
          title={ t('asset:upload.menuTitle') }
          menu={ { items:this.getToolbarItems() } }
        />
      </span>
    )
  }

  /**
  * Render Asset Items as list elements
  */
  render() {
    const {
      t,
      uid,
      tid,
      name,
      completed,
      progress
    } = this.props
    if (completed) return (
      <AssetItem uid={ uid } key={ uid }/>
    )
    let percent = Math.round(progress*100)+"%"
    return (
      <li
        className={ this.getListItemClass() }
        key={ tid }
        data-tid={ tid }
      >
        <div className="border">
          <div className="detail">
            <div
              className="progress"
              style={{position: "absolute", width:percent, height: "100%", backgroundColor:"#A0A0FF"}}
            >
            </div>
            <div className="label">
              {name}
            </div>
            { this.renderItemToolbar() }
          </div>
        </div>
      </li>
    )
  }
}

AssetUpload.propTypes = {
  tid: PropTypes.string.isRequired,
}

const mapStateToProps = getUploadItem

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      cancelUpload
    },
    dispatch
  )
}
/*
function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    ownProps
  )
}*/

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetUpload)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/asset/upload.jsx